const listSteps = [
  "kyc/personal-info",
  "kyc/validate-documents",
  "kyc/risk-profile",
  "kyc/knowledge-profile",
  "kyc/bad-trader-profile",
  "kyc/terms",
  "kyc/deposit",
]

export default listSteps
